<template>
  <b-dropdown
    id="dropdown-left"
    right
    variant="outline-primary"
    menu-class="dropdown-menu-lg"
    size="md"
    class="me-2 mb-2"
    :disabled="disabled"
  >
    <template #button-content>
      {{ $t('global.field.action') }}
      <i class="mc-fa icon-fill_chevron-down"></i>
    </template>
    <b-dropdown-item href="#">
      <b-button class="mc-button-action" @click="modalChangeStatus">
        <div class="d-flex align-items-center justify-content-center">
          {{ $t('maintenance.changeTo') }}
          <span class="font-size-16">
            <i class="mc-fa icon-fill_arrow-right mx-2"></i>
          </span>
          <span :class="`mc-status mc-status--blue`">
            {{ $t('maintenance.status.inService') }}
          </span>
        </div>
      </b-button>
    </b-dropdown-item>
    <b-dropdown-item href="#">
      <b-button class="mc-button-action" @click="modalFinishStatus">
        <div class="d-flex align-items-center justify-content-center">
          <span class="font-size-20">
            <i class="mc-fa icon-fill_checkmark"></i>
          </span>
          {{ $t('maintenance.serviceToNormal') }}
        </div>
      </b-button>
    </b-dropdown-item>

    <div v-if="!isDisabled">
      <b-dropdown-item href="#">
        <b-button class="mc-button-action" @click="handleCreateMO">
          {{ $t('maintenance.createMO') + ' (MO)' }}
        </b-button>
      </b-dropdown-item>
    </div>

    <b-dropdown-item href="#">
      <b-button class="mc-button-action delete-button" @click="handleDelete">
        <div class="d-flex align-items-center justify-content-center">
          <span class="font-size-20">
            <i class="mc-fa icon-outline_trash"></i>
          </span>
          {{ $t('global.delete') }}
        </div>
      </b-button>
    </b-dropdown-item>
    <div v-if="isDisabled">
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item href="#">
        <b-button class="mc-button-action" :disabled="isDisabled">
          {{ $t('maintenance.createMO') + ' (MO)' }}
        </b-button>
        <div :class="`text-disabled d-flex justify-content-center`" v-if="isDisabled">
          <strong> *{{ $t('maintenance.MOUnavailable') }} </strong>
        </div>
      </b-dropdown-item>
    </div>
  </b-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DropdownShortcut',

  props: {
    disabled: {},
    selectedIds: {},
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    isDisabled() {
      return !this.hasAccess([
        'service_order:read',
        'service_order:update',
        'service_order:create',
        'service_order:delete',
      ])
    },
  },

  methods: {
    modalFinishStatus() {
      this.$bvModal.show('modal-shortcut-finish-status')
    },
    modalChangeStatus() {
      this.$bvModal.show('modal-shortcut-change-status')
    },
    handleCreateMO() {
      this.$bvModal.show('modal-shortcut-create-mo')
    },

    handleDelete() {
      this.$bvModal.show('mc-modal-delete-bulk')
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.mc-button-action) {
  background-color: white;
  width: 100%;
  border: 1px solid $mep-primary;
  color: $mep-primary;
  font-weight: 600;
  padding: 5px 20px;
  min-width: 200px;
  white-space: nowrap;
  height: 38px;

  span {
    margin-right: 2px;
  }

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  &:hover {
    background-color: $mep-primary;
    border-color: $mep-primary;
    border: 1px solid white;
    color: white;
    .mc-status {
      color: white !important;
    }

    .icon-fill_arrow-right:before {
      content: '\e96e';
      color: white;
    }
    .icon-fill_checkmark:before {
      content: '\e949';
      color: white;
    }
  }

  &:disabled {
    border-color: grey;
    color: grey;

    &:hover {
      cursor: default;
    }
  }

  .mc-status {
    color: black !important;
  }
}

.hover-pointer {
  &:hover {
    cursor: pointer;
  }
}

.text-disabled {
  color: lightgray;
}

.delete-button {
  border: 1px solid $red !important;
  color: $red !important;

  &:hover {
    background-color: red !important;
    border-color: $red !important;
    border: 1px solid white !important;
    color: white !important;
  }
}
</style>
